import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushPinchIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 14c4-5 6-6 10-6s6 1 10 6",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 2.2,
			d: "M2 14c4-2 7-1 10 0s6 2 10 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 2.2,
			d: "m5 7 5 3",
			opacity: .6
		}),
		/* @__PURE__ */ _jsx("path", { d: "m5 7 2 1" }),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 2.2,
			d: "m19 7-5 3",
			opacity: .6
		}),
		/* @__PURE__ */ _jsx("path", { d: "m19 7-2 1" })
	]
});
export default SvgBrushPinchIcon;
